export * from './MACPPipesTab.component';
